module.exports = __webpack_public_path__ + "img/book3-active.b8590044.png";